module.exports = __webpack_public_path__ + "img/authorization-graph.svg";